<template>
	<div class="display-flex flex-column flex-justify-center height-100 width-100">
		<v-menu
			rounded="lg"
			:maxWidth="256"
			:minWidth="256"
			v-bind="$attrs"
			:nudge-left="20"
			class="width-100"
			v-on="$listeners"
			v-model="showMenu"
			:nudge-bottom="60"
			content-class="menu-content"
			:close-on-content-click="false"
		>
			<template v-slot:activator="{ on, attrs, value: isOpen }">
				<div
					v-on="on"
					v-bind="attrs"
					:class="{ selected: isOpen }"
					class="selector-container display-flex flex-row flex-justify-space-between width-100 height-100 flex-align-center pr-4"
				>
					<ProjectSelectorTitle v-bind="activatorProps" />
					<Col class="justify-between max-h-[10px] min-h-[10px]">
						<v-icon :color="isOpen ? '#5B5BE7' : '#646E87'" class="chevron-icon">mdi-chevron-up</v-icon>
						<v-icon :color="isOpen ? '#5B5BE7' : '#646E87'" class="chevron-icon">mdi-chevron-down</v-icon>
					</Col>
				</div>
			</template>
			<div class="width-100 menu-content-container">
				<ProjectMenu :selectedTabIndex="1" @close="showMenu = false" />
			</div>
		</v-menu>
	</div>
</template>

<script>
import ProjectMenu from '@/components/ProjectMenu/ProjectMenu.vue';
import { getProject } from '@/store/modules/projects/getters';
import { selectedProjectId } from '@/store/modules/selectedProject/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';
import { shortenText } from '@/utils/language-service';
import ProjectService from '@/utils/projects-service';
import {
	VIRTUAL_PROJECT_IDS,
	ALL_PROJECTS_VIRTUAL_ID,
	ALL_PROJECTS_VIRTUAL_TITLE,
	PROJECTS_SHARED_WITH_ME_VIRTUAL_ID,
	PROJECTS_SHARED_WITH_ME_VIRTUAL_TITLE,
} from '@/utils/projects.const';
import ProjectSelectorTitle from '@/views/AppLayout/ManageAndCreate/ProjectSelectorTitle.vue';

export default {
	name: 'SpaceSelector',
	props: {},
	components: {
		ProjectMenu,
		ProjectSelectorTitle,
	},
	computed: {
		...mapGettersShorthand({ getProject, selectedProjectId }),
		selectedProjectTitle() {
			const notFound = 'Space not found';
			if (!this.project) {
				if (this.isVirtualProject) {
					if (PROJECTS_SHARED_WITH_ME_VIRTUAL_ID === this.projectIdentifier) {
						return PROJECTS_SHARED_WITH_ME_VIRTUAL_TITLE;
					}
					return ALL_PROJECTS_VIRTUAL_TITLE;
				}
				return notFound;
			}

			return this.project?.title || notFound;
		},
		activatorProps() {
			return {
				title: this.selectedProjectTitle,
				description: this.selectedProjectDescription,
				isVirtualProject: this.isVirtualProject,
				isPersonalProject: this.isPersonalProject,
				isEverythingProject: this.projectIdentifier === ALL_PROJECTS_VIRTUAL_ID,
				isSharedWithMeProject: this.projectIdentifier === PROJECTS_SHARED_WITH_ME_VIRTUAL_ID,
			};
		},

		isVirtualProject() {
			return VIRTUAL_PROJECT_IDS.includes(this.projectIdentifier);
		},
		isPersonalProject() {
			return ProjectService.isPersonalProject(this.project);
		},
		project() {
			if (!this.projectIdentifier) {
				return null;
			}
			if (this.isVirtualProject) {
				return null;
			}
			return this.getProject(this.projectIdentifier);
		},
		projectIdentifier() {
			const identifier = this.selectedProjectId;
			return isNaN(identifier) ? identifier.toLowerCase() : identifier;
		},
		selectedProjectDescription() {
			if (!this.project) {
				if (this.projectIdentifier == ALL_PROJECTS_VIRTUAL_ID) {
					return 'All spaces';
				}
				if (this.projectIdentifier == PROJECTS_SHARED_WITH_ME_VIRTUAL_ID) {
					return 'Spaces shared with me';
				}
			}
			return shortenText(this.project?.description, 30);
		},
	},
	data() {
		return {
			showMenu: false,
		};
	},
};
</script>
<style scoped lang="scss">
.v-menu__content {
	contain: none !important; // this is to allow overflow from menu -- for pin-button-container
}
.selector-container {
	width: 100%;
	padding: 7px 5px;
	transition: 0.2s;
	border-radius: 6px;
	border: 1px solid #e9eaed;
	&.selected {
		transition: 0.2s;
		border-color: #5b5be7;
	}
}

$height: 440px;
$border-radius: 8px;
$vertical-padding: 20px;
.menu-content {
	max-height: $height;
	min-height: $height;
	background: var(--white);
	padding: 20px 12px 8px 12px;
	border-radius: $border-radius !important;
}
$projects-menu-width: 310px;
.pin-button-container {
	position: fixed;
	margin-top: -10px;
	margin-left: 281px;
}
.chevron-icon {
	width: 0px;
	height: 0px;
	font-size: 18px;
	color: #192e45;
}
.menu-content-container {
	height: calc(#{$height} - (#{$vertical-padding} * 2));
}
</style>
